<template>
  <div class="busRoute">
    <div class="busRoute__header1">
      <button class="btn-large primary" @click="addNew">Add New Placement</button>
    </div>
    <div class="busRoute__header2">
      <div class="busRoute__header2__search">
        <i class="adx-ic_search"></i>
        <input v-model="searchBoxValue" type="text" placeholder="Search" />
      </div>
      <div class="busRoute__header2__sort">
        <p>Sort by :</p>
        <div>
          <a-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sortOptions"></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="busRoute__listing">
      <div class="tableWrapper">
        <table>
          <thead>
            <tr>
              <td class="col1">PLACEMENT</td>
              <td class="col2">MIN ORDER</td>
              <td class="col2">BOTTOM PRICE</td>
              <td class="col2">PUBLIC PRICE</td>
              <td class="col2">FUTURE PRICE</td>
              <td class="col3"></td>
            </tr>
          </thead>

          <tbody v-if="!isLoading">
            <tr v-for="(location, index) in placements" :key="index" class="content">
              <td class="col1">
                <div class="routeGroup">
                  <div class="subhead route name">{{location.name}}</div>
                  <div class="small-font detail">{{location.billboardLocation.name}}</div>
                </div>
              </td>
              <td class="col2">
                <span class="subhead owner">{{location.minPeriod}}</span>
              </td>
              <td class="col2">
                <span class="subhead owner">{{location.bottomPrice | formatMoney}}</span>
              </td>
              <td class="col2">
                <span class="subhead owner">{{location.publicPrice | formatMoney}}</span>
              </td>
              <!-- <td v-if="location.billboardFuturePrice.length === 0" class="col2">
                <span>-</span>
              </td>
              <td
                v-else-if="location.billboardFuturePrice.length > 0 && location.billboardFuturePrice.length <= 2"
                class="col2"
              >
                <div
                  v-for="(price, index) in location.billboardFuturePrice"
                  :key="index"
                  class="subhead elipsis"
                >{{price.start}}</div>
              </td>
              <td v-else-if="location.billboardFuturePrice.length > 2" class="col2">
                <div :class="[show[index] ? '': 'hidden']">
                  <div
                    v-for="(placement, index) in location.billboardFuturePrice"
                    :key="index"
                    class="subhead elipsis"
                  >{{price.start}}</div>
                </div>
                <div v-if="!show[index]" class="showButton">
                  <span class="small-font toggleShow" @click="showMore(index)">Show More</span>
                  <i class="icon-chevrondown"></i>
                </div>
                <div v-else class="showButton">
                  <span class="small-font toggleShow" @click="showMore(index)">Show Less</span>
                  <i class="icon-chevronup"></i>
                </div>
              </td>-->
              <td v-if="location.billboardFuturePrice.length === 0" class="col2">
                <span>-</span>
              </td>
              <td v-else-if="location.billboardFuturePrice.length == 1" class="col2">
                <div
                  v-for="(price, index) in location.billboardFuturePrice"
                  :key="index"
                  class="subhead elipsis"
                >
                  <span class="color-grey mini-font">Start on:</span>
                  <br />
                  {{displayPeriod(price.start, price.end)}}
                  <label-status class="label" :progress="displayStatus(price.status)" />
                  <span class="color-grey mini-font">Bottom price:</span>
                  <br />
                  <span class="subhead">{{price.bottomPrice | formatMoney}}</span>
                  <br />
                  <span class="color-grey mini-font">Public price:</span>
                  <br />
                  <span class="subhead">{{price.publicPrice | formatMoney}}</span>
                </div>
              </td>
              <td v-else-if="location.billboardFuturePrice.length > 1" class="col2">
                <div :class="[show[index] ? '': 'hidden']">
                  <div
                    v-for="(price, index) in location.billboardFuturePrice"
                    :key="index"
                    class="subhead elipsis"
                  >
                    <span class="color-grey mini-font">Start on:</span>
                    <br />
                    <span class="subhead">{{displayPeriod(price.start, price.end)}}</span>
                    <label-status
                      class="dropdownDoc__item label"
                      :progress="displayStatus(price.status)"
                    />
                    <span class="color-grey mini-font">Bottom price:</span>
                    <br />
                    <span class="subhead">{{price.bottomPrice | formatMoney}}</span>
                    <br />
                    <span class="color-grey mini-font">Public price:</span>
                    <br />
                    <span class="subhead">{{price.publicPrice | formatMoney}}</span>
                  </div>
                </div>
                <div v-if="!show[index]" class="showButton">
                  <span class="small-font toggleShow" @click="showMore(index)">Show More</span>
                  <i class="icon-chevrondown"></i>
                </div>
                <div v-else class="showButton">
                  <span class="small-font toggleShow" @click="showMore(index)">Show Less</span>
                  <i class="icon-chevronup"></i>
                </div>
              </td>
              <td class="col3">
                <a-menu-expansion :lists="menuActions" @selected="selected($event, location)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="emptyState">
        <a-empty-selection v-if="placements.length == 0 && !isLoading" />
      </div>
      <div v-if="isLoading" class="table__loadingWrapper">
        <slot name="loading" />
        <a-loading />
      </div>
      <div class="pagination" v-if="!isLoading && placements.length > 0">
        <div class="total">{{getDataRange}} of {{count}} Placements</div>
        <a-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage" />
      </div>
    </div>
    <a-modal hideClose="true" v-if="isShowModal" title="Delete Placement" type="small">
      <div slot="content" class="busRoute__modal">
        <div class="busRoute__modal__top">
          <span>Sure want to delete this route?</span>
        </div>
        <div class="busRoute__modal__bottom">
          <button class="btn-regular primary" @click="deletePlacement">
            Yes
            <a-loading-2 class="btn-loading" v-if="isLoadingMutation" />
          </button>
          <button class="btn-regular primary" @click="cancelDelete">Cancel</button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  ALoadingPrimary,
  ALoadingSecondary,
  ALoadingSecondaryWhite,
  AEmptySelection,
  AModal,
  ASelectDropdown,
  APagination,
  AMenuExpansion,
  AStatusLabel
} from "ui-kit-v1";

import api from "@/api";
import { restEdge } from "@/api/edgeUrls";
import lib from "@/lib/util";
import moment from "moment";
import * as validationLib from "@/lib/validation/";

const { helpers } = validationLib;

export default {
  name: "adx-channel-billboard-placement",
  components: {
    "a-modal": AModal,
    "a-empty-selection": AEmptySelection,
    "a-loading": ALoadingPrimary,
    "a-loading-2": ALoadingSecondaryWhite,
    "a-dropdown-sort": ASelectDropdown,
    "a-pagination": APagination,
    "a-menu-expansion": AMenuExpansion,
    "label-status": AStatusLabel
  },
  props: {},
  data() {
    return {
      placements: [],
      searchBoxValue: "",
      selectedSortValue: "last_added",
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added"
        },
        {
          label: "First Added",
          value: "first_added"
        },
        {
          label: "Name",
          value: "name"
        }
      ],
      isLoading: false,
      show: [],
      selectedPage: 1,
      menuActions: [
        {
          id: 0,
          name: " Edit Placement",
          value: "editbillboardplacement"
        },
        {
          id: 1,
          name: " Duplicate Placement",
          value: "duplicatebillboardplacement"
        },
        {
          id: 2,
          name: "Delete Placement",
          value: "deletebillboardplacement"
        }
      ],
      menuActionsNot: [
        {
          id: 0,
          name: " Edit Placement",
          value: "editbillboardplacement"
        },
        {
          id: 1,
          name: " Duplicate Placement",
          value: "duplicatebillboardplacement"
        },
        {
          id: 2,
          name: "Delete Placement",
          value: "deletePlacement",
          disabled:
            "You must deactivate and unpublish this item first, before delete.",
          position: "top"
        }
      ],
      isEmpty: false,
      count: 0,
      maxPage: 1,
      isShowModal: false,
      status: { id: 4, value: "upcoming", label: "UPCOMING" },
      selectedPlacementId: 0
    };
  },
  computed: {
    getDataRange: function() {
      let endPage = this.selectedPage * 15;
      return this.count > 15
        ? endPage < this.count
          ? endPage
          : endPage - 15 + (this.count % 15)
        : this.count;
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(function() {
        this.selectedPage = 1;
        this.count = 0;
        this.loadData();
      });
    }, 500),
    selectedSortValue: helpers.debounce(function() {
      this.$nextTick(function() {
        this.selectedPage = 1;
        this.count = 0;
        this.loadData();
      });
    }, 500)
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    addNew() {
      this.$router.push({ name: "addnewbillboardplacement" });
    },
    showMore(index) {
      // assign array this way to make array change on DOM.
      this.$set(this.show, index, !this.show[index]);
    },
    selectPage(page) {
      this.selectedPage = page;
      this.count = 0;
      // this.getRoutes()
    },
    async loadData() {
      this.isLoading = true;
      const params = {
        search: this.searchBoxValue,
        page: this.selectedPage,
        sort: this.selectedSortValue
      };
      const response = await api.get(restEdge.getBillboardPlacement, {
        needToken: true,
        useRestEdge: true,
        params: params
      });

      if (response.status == 200) {
        this.placements = response.data.results;
        this.count = response.data.count;
      }

      this.isLoading = false;
    },
    selected(index, item) {
      if (index.value === "editbillboardplacement") {
        this.$router.push({
          name: "editbillboardplacement",
          params: { id: item.id }
        });
      } else if (index.value === "duplicatebillboardplacement") {
        this.duplicatePlacement(item.id);
      } else if (index.value === "deletebillboardplacement") {
        this.confirmDelete(item.id);
      }
    },
    toggleModal() {
      this.isShowModal = !this.isShowModal;
    },
    confirmDelete(id) {
      this.selectedPlacementId = id;
      this.toggleModal();
    },
    displayPeriod(start, end) {
      let startDate = moment(start, "YYYY-MM-DD");
      if (end) {
        let endDate = moment(end, "YYYY-MM-DD");
        return `${lib.dateFormat(
          "YYYY-MM-DD",
          "DD MMM YYYY",
          start
        )} - ${lib.dateFormat("YYYY-MM-DD", "DD MMM YYYY", end)}`;
      } else {
        return `${lib.dateFormat("YYYY-MM-DD", "DD MMM YYYY", start)} - Unset`;
      }
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status);
    },
    async deletePlacement() {
      this.isLoadingMutation = true;
      const response = await api.destroy(
        restEdge.deleteBillboardPlacement(this.selectedPlacementId),
        { needToken: true, useRestEdge: true }
      );
      if (response.status == 200) {
        this.toggleModal();
        this.loadData();
        this.isLoadingMutation = false;
        this.showNotificationAlert(
          "Success",
          "Data successfully deleted!",
          "success"
        );
      } else {
        this.toggleModal();
        this.loadData();
        this.isLoadingMutation = false;
        this.showNotificationAlert("Error", "Data failed to delete!", "danger");
      }
    },
    async duplicatePlacement(id) {
      this.isLoadingMutation = true;
      const response = await api.post(restEdge.duplicateBillboardPlacement(id), {}, { needToken: true, useRestEdge: true,});

      if (response.status == 200) {
        this.loadData();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully duplicated!', 'success')
      } else {
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to duplicate!', 'danger')
      }

    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>

<style lang="scss">
.status-label {
  .label {
    margin: 0 !important;
  }
}
</style>